<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import { Bar } from 'vue-chartjs';

export default {
  name: 'doughnut',
  extends: Bar,
  props: ['data', 'options'],
  mounted () {
    this.renderChart(this.data,  {
      responsive: true, 
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      plugins: {
          datalabels: {
            color: "white",
            textAlign: "center",
            font: {
              weight: "bold",
              size: 14
            },
            formatter: function(value, context) {
                return context.chart.data.labels[context.dataIndex];
            }
          }
      }
      })
  }
}
</script>